import {IconLoader2, IconRefresh, IconWallet} from "@tabler/icons-react";
import {Spin, Typography} from "@ui";
import {useEffect, useState} from "react";
import CurrencyDropdown from "../../../components/CurrencyDropdown";
import CurrencyManagementModal from "../../../components/CurrencyDropdown/CurrencyManagementModal";
import UserAvatar from "../../../components/NavBar/Avatar/index";
import NotificationMenu from "../../../components/notification";
import ThemeToggle from "../../../components/ThemeToggle/ThemeToggle";
import useGetUserWallet from "../../../hooks/wallet/useGetUserWallet";
import {useBalanceStore} from "../../../store/useBalance.store";
import useCurrencyStore from "../../../store/useCurrency.store";
import {formatCurrencyAmount} from "../../../util/balance.util";
import styles from "./NavbarWallet.module.css";

const Wallet = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [isSpinning, setIsSpinning] = useState(false);
  const widthResponsive = 1200;

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const {isLoading, balance, getAccountByCurrency, refetch} = useGetUserWallet();
  const {selectedCurrency} = useCurrencyStore();

  const handleBankAccountModal = useBalanceStore(state => state.handleBankAccountModal);

  const handleRefreshClick = () => {
    setIsSpinning(true);
    refetch();
    setTimeout(() => setIsSpinning(false), 700);
  };

  // Get account for selected currency
  const selectedAccount = selectedCurrency ? getAccountByCurrency(selectedCurrency.id) : balance;

  const formatDisplayBalance = () => {
    if (isLoading) {
      return (
        <Spin
          indicator={
            <IconLoader2
              size={16}
              className="icon-spin"
            />
          }
          size="small"
        />
      );
    }

    // Use the selected account or default to VES balance
    const accountToDisplay = selectedAccount || balance;

    if (accountToDisplay) {
      // Use frontend formatting to disambiguate currency symbols (e.g., US$ vs CL$)
      const currencyCode = selectedCurrency?.id || accountToDisplay.currency || "VES";
      return formatCurrencyAmount(accountToDisplay.balance, currencyCode);
    }

    return "Bs. 0,00";
  };

  return (
    <div className={styles.walletContainer}>
      <div className={styles.balanceChip}>
        <span className={styles.balanceEmoji}>💰</span>
        <div
          className={styles.balance_display}
          aria-live="polite"
          aria-atomic="true"
        >
          <Typography.Text className={styles.balance_text}>{formatDisplayBalance()}</Typography.Text>
        </div>
        <CurrencyDropdown />
        <IconRefresh
          size={16}
          onClick={handleRefreshClick}
          className={`${styles.icon_refresh} ${isSpinning ? styles.icon_refresh_spin : ""}`}
          aria-label="Actualizar saldo"
          role="button"
          tabIndex={0}
          onKeyDown={e => {
            if (e.key === "Enter" || e.key === " ") handleRefreshClick();
          }}
        />
      </div>
      <div className={styles.actionsGroup}>
        {windowWidth > widthResponsive && (
          <button
            type="button"
            onClick={() => handleBankAccountModal()}
            className={styles.wallet_icon}
            aria-label="Abrir billetera"
          >
            <IconWallet
              size={20}
              stroke={1.8}
            />
          </button>
        )}
        <ThemeToggle />
        <UserAvatar
          firstName="Ale"
          lastName="Beta"
        />
        <NotificationMenu />
      </div>
      <CurrencyManagementModal />
    </div>
  );
};

export default Wallet;
